import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes,
});

// Previne o crash "Cannot read properties of null (reading '_normalized')"
const originalPush = router.push.bind(router);
const originalReplace = router.replace.bind(router);

router.push = function safePush(location, onComplete, onAbort) {
  if (location == null) {
    console.warn("[router] push ignorado: destino é null/undefined");
    if (onComplete) onComplete();
    return Promise.resolve();
  }
  if (onComplete || onAbort) {
    return originalPush(location, onComplete, onAbort);
  }
  return originalPush(location).catch((err) => {
    if (err && err.name === "NavigationDuplicated") return;
    throw err;
  });
};

router.replace = function safeReplace(location, onComplete, onAbort) {
  if (location == null) {
    console.warn("[router] replace ignorado: destino é null/undefined");
    if (onComplete) onComplete();
    return Promise.resolve();
  }
  if (onComplete || onAbort) {
    return originalReplace(location, onComplete, onAbort);
  }
  return originalReplace(location).catch((err) => {
    if (err && err.name === "NavigationDuplicated") return;
    throw err;
  });
};

export default router;
